import WaiterStepper from 'components/WaiterStepper'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { injectIntl } from 'react-intl'
import styles from 'assets/styles/components/CategoryDetailList'
import injectSheet from 'react-jss'
import { bindActionCreators } from 'redux'
import * as basketActions from 'actions/components/basket'
import * as stepperActions from 'actions/components/stepper'
import * as optionGroupsActions from 'actions/components/optionGroups'

const mapStateToProps = (state) => {
  return {
    user: state.user,
    merchant: state.merchant,
    orders: state.orders,
    stash: state.stash,
    stashByOptionGroups: state.stashByOptionGroups,
    isActiveBottomSheetSubmitButton: state.isActiveBottomSheetSubmitButton,
    isSwitchOnEditMode: state.isSwitchOnEditMode,
    waiter: state.waiter,
  }
}

const mapDispatchToProps = (dispatch) => {
  const {
    addToOrder,
    setStash,
    resetStash,
  } = bindActionCreators(basketActions, dispatch)

  const {
    switchBottomSheet,
    activeBottomSheetSubmitButton,
  } = bindActionCreators(stepperActions, dispatch)

  const {
    resetStashByOptionGroups,
    resetStashByRadioGroups,
  } = bindActionCreators(optionGroupsActions, dispatch)

  return {
    addToOrder,
    setStash,
    resetStash,
    switchBottomSheet,
    resetStashByOptionGroups,
    resetStashByRadioGroups,
    activeBottomSheetSubmitButton,
  }
}

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(injectSheet(styles)(WaiterStepper))))



// WEBPACK FOOTER //
// ./src/containers/components/WaiterStepper.js